import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3 mb-lg-4" }
const _hoisted_4 = { class: "default-table-area all-projects" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table align-middle" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "d-flex align-items-center gap-1" }
const _hoisted_9 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_10 = { class: "material-symbols-outlined fs-16 text-primary" }
const _hoisted_11 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_12 = { class: "material-symbols-outlined fs-16 text-body" }
const _hoisted_13 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_14 = { class: "material-symbols-outlined fs-16 text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationTwo = _resolveComponent("PaginationTwo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "position-relative table-src-form me-0",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Search here",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event))
          }, null, 512), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y" }, " search ", -1))
        ], 32),
        _cache[3] || (_cache[3] = _createElementVNode("button", {
          class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg",
          "data-bs-toggle": "offcanvas",
          "data-bs-target": "#addNewCategoriesModal",
          "aria-controls": "addNewCategoriesModal"
        }, [
          _createElementVNode("span", { class: "py-sm-1 d-block" }, [
            _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block me-1" }),
            _createElementVNode("span", null, "Add New Categorie")
          ])
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("div", {
                    class: "form-check",
                    style: {"min-height":"auto"}
                  }, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      value: "",
                      id: "flexCheckDefault1"
                    })
                  ])
                ]),
                _createElementVNode("th", { scope: "col" }, "Image"),
                _createElementVNode("th", { scope: "col" }, "Name"),
                _createElementVNode("th", { scope: "col" }, "Total Products"),
                _createElementVNode("th", { scope: "col" }, "Slug"),
                _createElementVNode("th", { scope: "col" }, "Description"),
                _createElementVNode("th", { scope: "col" }, "Status"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _cache[4] || (_cache[4] = _createElementVNode("td", null, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault2"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("td", null, [
                    _createElementVNode("img", {
                      src: item.image,
                      class: "wh-40 rounded-3",
                      alt: ""
                    }, null, 8, _hoisted_7)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.name), 1),
                  _createElementVNode("td", null, _toDisplayString(item.totalProducts), 1),
                  _createElementVNode("td", null, _toDisplayString(item.slug), 1),
                  _createElementVNode("td", null, _toDisplayString(item.description), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.computeClass(item.status)])
                    }, _toDisplayString(item.status), 3)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("button", _hoisted_9, [
                        _createElementVNode("i", _hoisted_10, _toDisplayString(item.action.view), 1)
                      ]),
                      _createElementVNode("button", _hoisted_11, [
                        _createElementVNode("i", _hoisted_12, _toDisplayString(item.action.edit), 1)
                      ]),
                      _createElementVNode("button", _hoisted_13, [
                        _createElementVNode("i", _hoisted_14, _toDisplayString(item.action.delete), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode(_component_PaginationTwo, {
          items: "05",
          total: _ctx.items.length
        }, null, 8, ["total"])
      ])
    ])
  ]))
}